const CryptoJS = require('crypto-js')

export const Encrypt = string => {
  let key = process.env.REACT_APP_KEY
  let encrypted = CryptoJS.AES.encrypt(string, key)
  let encode = encode64(encrypted.toString())
  return encode
}

export const EncryptAPI = string => {
  let key = process.env.REACT_APP_KEY
  let encrypted = CryptoJS.AES.encrypt(string, key)
  return String(encrypted)
}

export const DecryptAPI = crypt => {
  let key = process.env.REACT_APP_KEY
  let decrypted = CryptoJS.AES.decrypt(crypt, key)
  return decrypted.toString(CryptoJS.enc.Utf8)
}

export const Decrypt = crypt => {
  if (!crypt) {
    return '0_0'
  }

  let key = process.env.REACT_APP_KEY
  let decode = decode64(crypt)
  let decrypted = CryptoJS.AES.decrypt(decode, key)
  return decrypted.toString(CryptoJS.enc.Utf8)
}

export const EncryptArray = data => {
  let key = process.env.REACT_APP_KEY

  let ciphertext = CryptoJS.AES.encrypt(JSON.stringify(data), key).toString()
  return ciphertext
}

export const DecryptArray = cipherdata => {
  let key = process.env.REACT_APP_KEY

  // Decrypt
  let bytes = CryptoJS.AES.decrypt(cipherdata, key)
  let decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8))

  return decryptedData
}

function encode64(myString) {
  // PROCESS
  const encodedWord = CryptoJS.enc.Utf8.parse(myString) // encodedWord Array object
  const encoded = CryptoJS.enc.Base64.stringify(encodedWord) // string: 'NzUzMjI1NDE='
  return encoded
}

function decode64(encoded) {
  // PROCESS
  const encodedWord = CryptoJS.enc.Base64.parse(encoded) // encodedWord via Base64.parse()
  const decoded = CryptoJS.enc.Utf8.stringify(encodedWord) // decode encodedWord via Utf8.stringify() '75322541'
  return decoded
}
